import { useContext, useEffect } from "react";
import styled from "styled-components";
import { theme } from "./Theme";
import { PortfolioContext } from "./AppContext";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";
import LazyLoad from "react-lazyload";
import moi from "../assets/moi.jpg";
import me from "../assets/me.mp4";
import ReactPlayer from "react-player";

gsap.registerPlugin(ScrollTrigger, SplitText);
const About = () => {
	const { setEnterAboutMe } = useContext(PortfolioContext);

	// useEffect(() => {
	// 	gsap.set(".quote", { opacity: 1 });

	// 	document.fonts.ready.then(() => {
	// 		const containers = gsap.utils.toArray(".split");

	// 		containers.forEach((text) => {
	// 			const split = new SplitText(text, {
	// 				type: "lines",
	// 				linesClass: "line",
	// 			});

	// 			gsap.from(split.lines, {
	// 				yPercent: 100,
	// 				opacity: 0,
	// 				stagger: 0.1,
	// 				ease: "power3.out",
	// 				duration: 0.6,
	// 				scrollTrigger: {
	// 					trigger: text,
	// 					start: "top 85%",
	// 					end: "bottom 40%",
	// 					toggleActions: "play none none reverse",
	// 					markers: false,
	// 				},
	// 			});
	// 		});
	// 	});
	// }, []);

	return (
		<Div
			data-bg="beige"
			onMouseEnter={() => setEnterAboutMe(true)}
			onMouseLeave={() => setEnterAboutMe(false)}
		>
			<AboutContainer>
				<InfoContainer>
					<TextContainer className="quote">
						<h1 className=" header">A little bit about me</h1>
						<p className="split">
							Hii, <span>I’m Iqra</span>, a creative developer based in
							Montreal. My journey into tech started in the most unexpected
							place: <span>a kitchen full of potato recipes</span>. Since then,
							I’ve been creating with React and JavaScript, always aiming to
							blend functionality with thoughtful design. I’ve been writing code
							for a couple of years, mostly with React and JavaScript.
						</p>
						<p className="split">
							I’ve recently fallen in love with creative work. A spark that’s
							led me to explore both graphic design and brand design. In many
							ways, it feels like coming full circle,
							<span>
								since I’ve always been drawn to art and fashion as a kid.
							</span>{" "}
							It’s been exciting (and slightly terrifying) to start from scratch
							again, but there's something so rewarding about learning to make
							beautiful things.
						</p>
						<p className="split">
							A few fun facts about me: I love going to the gym (mainly to
							justify all the sweet treats I eat). I enjoy getting lost in a
							good book, I just finished{" "}
							<span>A Little Life by Hanya Yanagihara</span> and still haven’t
							emotionally recovered. And honestly, nothing beats a slow morning
							coffee, some sunshine, and a warm summer evening spent with
							friends and family.
						</p>
					</TextContainer>
					<HeaderContainer>
						<LazyLoad>
							<PlayerContainer>
								<ReactPlayer
									url={me}
									playing
									loop
									autoPlay
									muted
									playsinline
									controls={false}
									width="100%"
									height="auto"
									config={{
										file: {
											attributes: {
												playsInline: true,
												controls: false,
												muted: true,
												autoPlay: true,
											},
										},
									}}
								/>
							</PlayerContainer>
						</LazyLoad>
					</HeaderContainer>
				</InfoContainer>
			</AboutContainer>
		</Div>
	);
};

export default About;

const Div = styled.div`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 100vh;
	width: 100vw;
	color: var(--v2);
	background-color: var(--v1);
`;

const AboutContainer = styled.div`
	width: 100%;
	max-width: 1400px;
	min-height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 60px 40px;
	box-sizing: border-box;

	@media (max-width: ${theme.breakpoints.md}) {
		padding: 40px 24px;
	}

	@media (max-width: ${theme.breakpoints.sm}) {
		padding: 32px 16px;
	}
`;

const InfoContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	gap: 48px;
	width: 100%;

	@media (max-width: ${theme.breakpoints.md}) {
		flex-direction: row;
		align-items: flex-start;
		gap: 24px;
	}

	@media (max-width: ${theme.breakpoints.sm}) {
		position: relative;
		flex-direction: column;
		align-items: stretch;
		gap: 0;
	}
`;

const TextContainer = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	color: var(--v2);
	min-width: 0;

	.header {
		font-size: clamp(24px, 4vw, 40px);
		font-family: "Darline script";
		font-weight: 200;
		font-style: normal;
		width: 100%;
		margin-bottom: 16px;
		line-height: 1.2;
	}

	.split {
		font-family: "Poppins", sans-serif;
		text-align: start;
		line-height: 1.7;
		padding: 0px 5px;
		width: 100%;
		font-size: clamp(12px, 1.2vw, 15px);
		will-change: transform;
	}

	.split * {
		will-change: transform;
	}

	span {
		background-color: var(--v4);
		font-style: italic;
		padding: 0 4px;
		border-radius: 4px;
	}

	@media (max-width: ${theme.breakpoints.sm}) {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 10;
		padding: 24px 16px;
		overflow-y: auto;
		

		.header {
			font-size: clamp(22px, 6vw, 32px);
			font-weight: 700;
			color: #fff;
		}

		.split {
			font-size: clamp(12px, 3.2vw, 14px);
			font-weight: 700;
			padding: 0 4px;
			line-height: 1.6;
			color: #fff;
		}

		span {
			background-color: rgba(255, 255, 255, 0.25);
			color: #fff;
		}
	}
`;

const HeaderContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	flex-shrink: 0;

	@media (max-width: ${theme.breakpoints.md}) {
		justify-content: center;
	}

	@media (max-width: ${theme.breakpoints.sm}) {
		position: relative;
		width: 100%;
		height: 100vh; 
	}
`;

const PlayerContainer = styled.div`
	width: 380px;
	height: auto;

	video {
		border-radius: 12px;
		object-fit: cover;
	}

	@media (max-width: ${theme.breakpoints.md}) {
		width: 260px;
	}

	@media (max-width: ${theme.breakpoints.sm}) {
		width: 100%;
		height: 100vh;

		/* make ReactPlayer fill the container */
		> div {
			width: 100% !important;
			height: 100% !important;
		}

		video {
			width: 100%;
			height: 100%;
			object-fit: cover;
			border-radius: 0;
		}
	}
`;
